import {AnyEvent, JOB_IMPORT_LOADED, JobImportLoadedEvent} from '../type';

export default function jobImportLoaded(payload: JobImportLoadedEvent['payload']): AnyEvent {
  return {
    type: JOB_IMPORT_LOADED,
    payload,
  }
}